export default "__VITE_ASSET__CtnGkz0X__"